import { useEffect, useState } from 'react'
import { CIMSCollapseCountsExtraProps, CountChange } from './types'
import { Space } from 'antd'
import CountItem from './Components/CountItem'

const CIMSCollapseCountsExtra: React.FC<CIMSCollapseCountsExtraProps> = ({
  counts = [],
  onCountsChange,
  extra,
}) => {
  const [countsByKey, setCountsByKey] = useState<CountChange[]>([])
  useEffect(() => {
    onCountsChange?.(countsByKey)
    // don't include onCountChange here to avoid infinite re-renders
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countsByKey])
  return (
    <Space size="small" align="center">
      {extra}
      {counts.map(({ key, onCountChange, ...rest }) => (
        <CountItem
          onCountChange={(count) => {
            setCountsByKey((prev) => [
              ...prev.filter(({ key }) => count.key !== key),
              count,
            ])
            onCountChange?.(count)
          }}
          key={key}
          {...rest}
        />
      ))}
    </Space>
  )
}

export default CIMSCollapseCountsExtra
